import { useContext } from 'react';
import { ACCESS_CHECK_DROPDOWN_ITEM_WRAPPER_DISPLAY_NAME } from '../../../../constants/accessCheckDropdownItemWrapperDisplayName';
import { AccessCheckDropdownContext } from '../../../../contexts/AccessCheckDropdownContext';
import { ActionableItemDisplayWrapper } from '../AccessCheckActionableItemWrapper/ActionableItemDisplayWrapper';
import { enrichRequestAccessConfig } from '../../../../utils/enrichRequestAccessConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export function AccessCheckDropdownItemWrapper({
  props,
  dropdownItemId,
  children
}) {
  var _props$taskDescriptio;
  const {
    accessInfoMap,
    hasAllGates: hasAllRequiredGates
  } = useContext(AccessCheckDropdownContext);
  if (!hasAllRequiredGates) {
    return children;
  }
  const accessInfo = dropdownItemId ? accessInfoMap.get(dropdownItemId) : undefined;
  if (!accessInfo) {
    return null;
  }
  return /*#__PURE__*/_jsx(ActionableItemDisplayWrapper, {
    accessInfo: accessInfo,
    contentOverride: props.contentOverride,
    taskDescription: (_props$taskDescriptio = props.taskDescription) !== null && _props$taskDescriptio !== void 0 ? _props$taskDescriptio : '',
    requestAccessConfig: enrichRequestAccessConfig(props),
    children: children
  });
}
AccessCheckDropdownItemWrapper.displayName = ACCESS_CHECK_DROPDOWN_ITEM_WRAPPER_DISPLAY_NAME;